export const getParameterFromURL = (url: string, parameterKey: string) => {
  try {
    const preparedURL = new URL(url)
    const params = new URLSearchParams(preparedURL.search)
    return params.get(parameterKey)
  } catch (err) {
    return null
  }
}
